import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronRight, ChevronDown, ChevronUp, Home } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
const leaders = [{
  name: 'Hon. Frank Tumwebaze',
  title: 'Minister of Agriculture, Animal Industry and Fisheries',
  image: 'https://cdn.magicpatterns.com/uploads/2avawG6XUnoaLV97aH7mKL/wmremove-transformed_(2).jpg',
  summary: 'The Office of the Minister for Agriculture, Animal Industry and Fisheries is provided for in Article 111 of the Constitution of the Republic of Uganda. Hon. Frank Tumwebaze is the Member of Parliament for Kibale County, appointed to this position on 8th June 2021.',
  details: ['The Cabinet Minister is accountable to the President of the Republic of Uganda and to Parliament for the exercise of two fundamental responsibilities:'],
  responsibilities: ['Individual performance related to his/her portfolio within the Government as Minister for Agriculture, Animal Industry and Fisheries', 'Collective performance of the Government'],
  duties: ['Sworn to carry out the powers, duties and functions of his/her portfolio', 'Responsible for the policies, programs and administration of the Ministry', 'The source of policy and program initiatives', 'Vested with Departmental powers, duties and functions through various Acts of Parliament', "Individually responsible to Parliament for his/her actions, the policies and practices of the Ministry including the actions of all officials under his/her management and direction and the policies and practices of any non-departmental bodies such as Agencies, Boards and Commissions within the Minister's portfolio"]
}, {
  name: 'Hon. Bwino Fred Kyakulaga (MP)',
  title: 'Minister of State for Agriculture',
  image: 'https://cdn.magicpatterns.com/uploads/oW5E5GygotwVZsJJevdCC4/hk1LvUFo_400x400.jpg',
  summary: 'The Office of the Minister of State for Agriculture is provided for in Article 114 of the Constitution of the Republic of Uganda, which provides that the President may, with the approval of Parliament, appoint other Ministers to assist Cabinet Ministers in the performance of their functions. Ministers of State are appointed from among Members of Parliament or persons qualified to be elected Members of Parliament. Hon. Bwino Fred Kyakulaga (MP) serves as the Minister of State for Agriculture.',
  details: [],
  responsibilities: [],
  duties: []
}, {
  name: 'Hon. Lt. Col (Rtd) Bright Rwamirama',
  title: 'Minister of State for Animal Industry',
  image: 'https://cdn.magicpatterns.com/uploads/anQU85FMNT2FjjThtU8rPY/UyvAquoL_400x400.jpg',
  summary: 'The Office of the Minister of State for Animal Industry is provided for in Article 114 of the Constitution of the Republic of Uganda, which provides that the President may, with the approval of Parliament, appoint other Ministers to assist Cabinet Ministers in the performance of their functions. Ministers of State are appointed from among Members of Parliament or persons qualified to be elected Members of Parliament. Hon. Lt. Col (Rtd) Bright Rwamirama serves as the Minister of State for Animal Industry. Follow on Twitter: @LtRwamirama.',
  details: [],
  responsibilities: [],
  duties: []
}, {
  name: 'Maj. Gen. David Kasura Kyomukama',
  title: 'Permanent Secretary',
  image: 'https://cdn.magicpatterns.com/uploads/ccuGZ2VpMxdic3mQkG3a5P/WhatsApp-Image-2021-08-20-at-12.32.33-Photoroom.png',
  summary: 'The Office of the Permanent Secretary is provided for by Article 174 of the Constitution of the Republic of Uganda. The Permanent Secretary is appointed by the President on the advice of the Public Service Commission. Maj. Gen. David Kasura Kyomukama serves as the Permanent Secretary of the Ministry of Agriculture, Animal Industry and Fisheries.',
  details: ["The Permanent Secretary's duties as spelt out in Article 174 of the Constitution include:"],
  responsibilities: [],
  duties: ['The organization and operation of the Ministry', 'Tendering advice to the responsible Minister in respect to the business of the Ministry. The Permanent Secretary is the Principal Policy Advisor to the Minister', 'Implementation of the policies of Government', 'Responsibility for the proper expenditure of public funds by or in connection with the Ministry']
}];
const directors = [{
  name: 'Commissioner for Crop Resources',
  directorate: 'Directorate of Crop Resources'
}, {
  name: 'Commissioner for Animal Resources',
  directorate: 'Directorate of Animal Resources'
}, {
  name: 'Commissioner for Fisheries Resources',
  directorate: 'Directorate of Fisheries Resources'
}, {
  name: 'Commissioner for Agricultural Extension',
  directorate: 'Directorate of Agricultural Extension Services'
}];
function LeaderCard({
  leader,
  index
}: {
  leader: (typeof leaders)[0];
  index: number;
}) {
  const [expanded, setExpanded] = useState(false);
  const hasMore = leader.duties.length > 0 || leader.responsibilities.length > 0;
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay: index * 0.1
  }} className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden flex flex-col" data-id="element-908">
      <div className="flex flex-col sm:flex-row" data-id="element-909">
        <div className="sm:w-40 h-48 sm:h-auto flex-shrink-0" data-id="element-910">
          <img src={leader.image} alt={leader.name} className="w-full h-full object-cover" data-id="element-911" />
        </div>
        <div className="p-6 flex-1 flex flex-col" data-id="element-912">
          <p className="text-xs font-bold text-uganda-green uppercase tracking-wider mb-1" data-id="element-913">
            {leader.title}
          </p>
          <h3 className="text-xl font-bold text-uganda-black mb-3" data-id="element-914">
            {leader.name}
          </h3>
          <p className="text-sm text-gray-500 leading-relaxed flex-grow" data-id="element-915">
            {leader.summary}
          </p>

          {hasMore && <button onClick={() => setExpanded(!expanded)} className="inline-flex items-center gap-1 text-sm font-semibold text-uganda-green hover:text-green-800 transition-colors mt-4" data-id="element-916">
              {expanded ? 'Show Less' : 'Read Full Details'}
              {expanded ? <ChevronUp className="w-4 h-4" data-id="element-917" /> : <ChevronDown className="w-4 h-4" data-id="element-918" />}
            </button>}
        </div>
      </div>

      <AnimatePresence data-id="element-919">
        {expanded && hasMore && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-920">
            <div className="px-6 pb-6 pt-2 border-t border-gray-100 bg-gray-50/50" data-id="element-921">
              {leader.details.map((detail, i) => <p key={i} className="text-sm text-gray-600 mb-3" data-id="element-922">
                  {detail}
                </p>)}

              {leader.responsibilities.length > 0 && <div className="mb-4" data-id="element-923">
                  <h4 className="text-sm font-bold text-uganda-black mb-2" data-id="element-924">
                    Key Responsibilities:
                  </h4>
                  <ul className="space-y-2" data-id="element-925">
                    {leader.responsibilities.map((r, i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-600" data-id="element-926">
                        <span className="text-uganda-green font-bold mt-0.5" data-id="element-927">
                          ({String.fromCharCode(105 + i)})
                        </span>
                        {r}
                      </li>)}
                  </ul>
                </div>}

              {leader.duties.length > 0 && <div data-id="element-928">
                  <h4 className="text-sm font-bold text-uganda-black mb-2" data-id="element-929">
                    {leader.responsibilities.length > 0 ? 'The holder of this Office is by law:' : 'Constitutional Duties:'}
                  </h4>
                  <ul className="space-y-2" data-id="element-930">
                    {leader.duties.map((d, i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-600" data-id="element-931">
                        <span className="text-uganda-green font-bold mt-0.5" data-id="element-932">
                          ({String.fromCharCode(105 + i)})
                        </span>
                        {d}
                      </li>)}
                  </ul>
                </div>}
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}
export function LeadershipPage() {
  return <>
      <Header data-id="element-933" />
      <main className="flex-grow pt-[160px] md:pt-[148px] bg-gray-50 pb-20" data-id="element-934">
        <div className="relative text-white py-32 md:py-48 overflow-hidden" data-id="element-935">
          <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1595508064774-5ff825a66368?w=1600&h=600&fit=crop")'
        }} data-id="element-936"></div>
          <div className="absolute inset-0 bg-uganda-green/80" data-id="element-937"></div>
          <div className="relative max-w-7xl mx-auto px-4 md:px-8" data-id="element-938">
            <div className="flex items-center text-sm text-green-100 mb-6" data-id="element-939">
              <Link to="/" className="hover:text-white flex items-center" data-id="element-940">
                <Home className="w-4 h-4 mr-1" data-id="element-941" /> Home
              </Link>
              <ChevronRight className="w-4 h-4 mx-2" data-id="element-942" />
              <span data-id="element-943">About MAAIF</span>
              <ChevronRight className="w-4 h-4 mx-2" data-id="element-944" />
              <span className="text-white font-medium" data-id="element-945">Leadership</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-946">
              Ministry Leadership
            </h1>
            <p className="text-lg text-green-50 max-w-3xl leading-relaxed" data-id="element-947">
              Meet the political and administrative leaders guiding the Ministry
              of Agriculture, Animal Industry and Fisheries.
            </p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-8 mt-12" data-id="element-948">
          <h2 className="text-2xl font-bold text-uganda-black mb-6" data-id="element-949">
            Political & Administrative Leadership
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-950">
            {leaders.map((leader, index) => <LeaderCard key={leader.name} leader={leader} index={index} data-id="element-951" />)}
          </div>

          <h2 className="text-2xl font-bold text-uganda-black mb-6" data-id="element-952">
            Technical Directors
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-953">
            {directors.map((dir, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 flex items-center gap-4" data-id="element-954">
                <div className="w-12 h-12 rounded-full bg-uganda-light-green text-uganda-green flex items-center justify-center flex-shrink-0 font-bold text-lg" data-id="element-955">
                  {dir.name.charAt(0)}
                </div>
                <div data-id="element-956">
                  <h3 className="font-bold text-uganda-black" data-id="element-957">{dir.name}</h3>
                  <p className="text-sm text-gray-500" data-id="element-958">{dir.directorate}</p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </main>
      <Footer data-id="element-959" />
    </>;
}